import React from 'react'

import FormManager from "../../../../gd-form/common/form-manager"
import CustomFieldAddFormProto, {CustomFieldAddFormProto_Props} from "../../add-form-proto"
import CustomFieldLeftPanel from "../../common/panel/form-left-panel"
import CustomFieldPreview from "../../common/form-preview"
import CustomFieldRightPanel from "../../common/panel/form-right-panel"
import CustomFieldMaxSize from "../../common/form-max-size"

export default class TextCustomFieldForm extends CustomFieldAddFormProto {

    public form: FormManager

    constructor(props: CustomFieldAddFormProto_Props) {
        super(props)

        this.type = gd.const.customFields.type.TEXT

        this.initFormData.size = 4

        if (this.props.customField) {
            this.initFormData.size = _.get(this.props.customField.params,'size', 4)
        }

        this.formStructure.fields.size = {
            type            : 'select',
            isRequired      : true,
            label           : 'Size',
            onUserChange    : () => this.setState({reRender: 1})
        }

        this.form = new FormManager(this.formStructure, this.initFormData)
    }

    onSubmit(result: any) {
        result.name = result.name.trim()
        result.type = gd.const.customFields.type.TEXT

        result.params = {
            displayName : result.displayName?.trim(),
            size        : result.size,
            scope       : result.scope
        };

        this.props.onSubmit(result);
    }

    render() {
        return (
            <React.Fragment>
                <CustomFieldLeftPanel parent={this}>
                    <CustomFieldPreview>
                        <div className="txt m-l-15">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras aliquam, urna eleifend venenatis luctus, eros ex egestas justo, congue consequat leo leo a turpis.</div>
                    </CustomFieldPreview>
                </CustomFieldLeftPanel>

                <CustomFieldRightPanel parent={this}>
                    <CustomFieldMaxSize form={this.form}/>
                </CustomFieldRightPanel>
            </React.Fragment>
        )
    }
}